import { useSearchParams } from 'react-router-dom';

import Action from '@/components/Action';
import Button from '@/components/Button';
import Card from '@/components/Card';
import Modal from '@/components/Modal';
import Stack from '@/components/Stack';
import { Body, Small } from '@/components/Typography';

import { InvitePayload } from '../utils/buildInvitePayload';

type OrderType = {
  id: string;
};

type Props = {
  order: OrderType;
  hideModal: () => void;
  hireMessage?: string | null;
  invitePayload?: InvitePayload | null;
};

const PostSubmitModal = ({
  order,
  hideModal,
  hireMessage,
  invitePayload,
}: Props) => {
  const [searchParams] = useSearchParams();
  const isDebug = searchParams.get('debug') === 'true';

  return (
    <Modal
      disableClickout
      size={isDebug ? 'md' : 'xs'}
      title={`Order #${order.id} placed!`}
      wrapperBackground={true}
      onRequestClose={hideModal}
    >
      <Card.Section>
        <Stack vertical gap={24}>
          <Body>Your order #{order.id} was successfully placed.</Body>
          {hireMessage && <Body>{hireMessage}</Body>}
          {isDebug && invitePayload && (
            <div>
              <Small weight="medium">
                Debug: Worker invite/hire details (included in order creation)
              </Small>
              <pre
                style={{
                  backgroundColor: '#f5f5f5',
                  padding: '12px',
                  borderRadius: '4px',
                  overflow: 'auto',
                  maxHeight: '300px',
                  fontSize: '12px',
                  marginTop: '8px',
                }}
              >
                {JSON.stringify(invitePayload, null, 2)}
              </pre>
            </div>
          )}
          <Stack justify="end">
            <Button
              a11yLabel="Start a new order"
              appearance="outline"
              id="start-new-order"
              label="Place another"
              onClick={hideModal}
            />
            <Action.Button
              action={{
                a11yLabel: 'Navigate to order page',
                id: 'view-order-btn',
                label: 'View order',
                to: `/orders/${order.id}`,
              }}
              appearance="primary"
            />
          </Stack>
        </Stack>
      </Card.Section>
    </Modal>
  );
};

export default PostSubmitModal;
